import { THEME_SYSTEM } from "../components/utils";

export const MIN_EMAILS_PER_DAY = 1;
export const MAX_EMAILS_PER_DAY = 20;
export const DEFAULT_MAX_EMAILS_PER_DAY = 10;

/** Default activity-email flags; all on until the user opts out. */
export const DEFAULT_NOTIFICATIONS = {
  email: true,
  newMessages: true,
  mentions: true,
  connectionRequests: true,
  connectionActivity: true,
  organizationUpdates: true,
  postLikes: true,
  postComments: true,
  maxEmailsPerDay: DEFAULT_MAX_EMAILS_PER_DAY,
};

/**
 * Clamp a daily email cap to the allowed 1–20 range, or the default.
 * @param {*} value
 * @returns {number}
 */
export function clampMaxEmailsPerDay(value) {
  const parsed = typeof value === "number" ? value : Number.parseInt(String(value), 10);
  if (!Number.isInteger(parsed)) {
    return DEFAULT_MAX_EMAILS_PER_DAY;
  }
  return Math.min(MAX_EMAILS_PER_DAY, Math.max(MIN_EMAILS_PER_DAY, parsed));
}

/**
 * Strip the DBDict `type` field from a settings API payload.
 * @param {Object} [data]
 * @returns {Object}
 */
export function settingsFromResponse(data) {
  if (!data || typeof data !== "object") {
    return {};
  }
  const { type: _type, ...rest } = data;
  return rest;
}

/**
 * Normalize a user settings document with defaults.
 * @param {Object} [raw]
 * @returns {{ theme: string, notifications: Object }}
 */
export function normalizeUserSettings(raw) {
  const source = settingsFromResponse(raw);
  const notifications = { ...DEFAULT_NOTIFICATIONS, ...(source.notifications || {}) };
  notifications.maxEmailsPerDay = clampMaxEmailsPerDay(notifications.maxEmailsPerDay);
  return {
    theme: source.theme || THEME_SYSTEM,
    notifications,
  };
}

/**
 * Normalize an organization settings document.
 * @param {Object} [raw]
 * @returns {{ theme: string }}
 */
export function normalizeOrgSettings(raw) {
  const source = settingsFromResponse(raw);
  return {
    theme: source.theme || THEME_SYSTEM,
  };
}

/**
 * Theme stored on the signed-in account, or system if unset.
 * @param {Object} [account]
 * @returns {string}
 */
export function themeFromAccount(account) {
  const theme = account?.settings?.theme;
  return theme || THEME_SYSTEM;
}
